export const resolveProductImageUrl = (value?: string | null) => {
  if (!value) {
    return "";
  }

  if (/^(data:|https?:\/\/|\/\/|blob:)/i.test(value)) {
    return value;
  }

  return value.startsWith("/") ? value : `/${value}`;
};
